import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

const initialState = {
    dependentCurve: { label: '', value: null },
    independentCurve: { label: '', value: null },
    structure1: null,
    structure2: null,
    isFwd: false,
    isImm: false,
    meetingDate: '',
    immFwd: null,
    immLabel: null
};

let irsContextSlice = (set) => ({
    ...initialState,
    updateContext: (data) => set((state) => ({ ...state, ...data })),
    resetContext: () => set(initialState)
});

irsContextSlice = immer(irsContextSlice);
const useIrsContextStore = create(irsContextSlice);

export default useIrsContextStore;
